import React from 'react';
import './Button.css';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  fullWidth = false,
  type = 'button',
  className = '',
  ...props
}) => {
  const classes = [
    'p-btn',
    `p-btn--${variant}`,
    `p-btn--${size}`,
    fullWidth && 'p-btn--full',
    loading && 'p-btn--loading',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className="p-btn__spinner" />}
      {children}
    </button>
  );
};

export default Button;
